export const LEGAL_VERSIONS = {
  termsVersion: "1.3",
  privacyVersion: "1.3",
};
